import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { LayoutService } from 'src/app/_core/services/layout.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserState } from 'src/app/_user/store/user/user.state';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private store: Store,
                private layoutService: LayoutService) {
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): boolean | Observable<boolean> {
        if (!this.layoutService.isUserConnected || this.store.selectSnapshot(UserState.isFirstTimeLogin)) {
            return this.layoutService.navigateToLogin().pipe(map(() => false));
        } else {
            return true;
        }
    }
}
